import { Uuid } from '~src/utils/UUID';
import { z } from 'zod';

export const UploadMediaResponse = z.object({
  id: z
    .string()
    .uuid()
    .transform((u) => Uuid.from_string(u)),
});

export type UploadMediaResponse = z.infer<typeof UploadMediaResponse>;
